import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconEyeLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.002 15.577c1.133 0 2.096-.397 2.887-1.19.792-.793 1.188-1.756 1.188-2.89 0-1.132-.397-2.095-1.19-2.886-.793-.792-1.756-1.188-2.89-1.188-1.133 0-2.095.397-2.887 1.19-.791.793-1.187 1.756-1.187 2.89 0 1.132.397 2.095 1.19 2.886.793.792 1.756 1.188 2.89 1.188ZM12 14.2c-.75 0-1.387-.262-1.912-.787A2.604 2.604 0 0 1 9.3 11.5c0-.75.262-1.387.787-1.912A2.604 2.604 0 0 1 12 8.8c.75 0 1.387.262 1.912.787.525.526.788 1.163.788 1.913s-.262 1.387-.787 1.912A2.604 2.604 0 0 1 12 14.2Zm0 4.3c-2.105 0-4.03-.562-5.776-1.685a12.571 12.571 0 0 1-4.18-4.432 1.763 1.763 0 0 1-.183-.434 1.759 1.759 0 0 1 .183-1.332 12.573 12.573 0 0 1 4.18-4.432C7.969 5.062 9.894 4.5 12 4.5c2.105 0 4.03.562 5.776 1.685a12.572 12.572 0 0 1 4.18 4.432c.083.144.144.289.183.434a1.76 1.76 0 0 1-.183 1.332 12.571 12.571 0 0 1-4.18 4.432C16.031 17.938 14.106 18.5 12 18.5Zm0-1.5a9.544 9.544 0 0 0 5.188-1.488A9.774 9.774 0 0 0 20.8 11.5a9.773 9.773 0 0 0-3.613-4.013A9.545 9.545 0 0 0 12 6a9.545 9.545 0 0 0-5.188 1.487A9.773 9.773 0 0 0 3.2 11.5a9.773 9.773 0 0 0 3.612 4.012A9.544 9.544 0 0 0 12 17Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEyeLine;
